<molecule-search-bar
    [isLoading]="isLoading"
    [searchType]="searchType"
    [searchTypePlural]="searchTypePlural"
    [totalRecordCount]="totalRecordCount"
    [inputSearchText]="inputSearchText"
    [placeholder]="placeholder"
    [sortMenu]="sortMenu"
    [alwaysShowFilters]="alwaysShowFilters"
    [showSearchBar]="showSearchBar"
    [filterHandler]="filterHandler"
    [filterFormId]="filterFormId"
    [filterModalId]="instanceId"
    [hasMobileFilter]="hasMobileFilter"
    (searchTriggered)="onSearch($event)"
    (sort)="onSort($event)"
>
    <ng-content prefixActionButtons select="[prefixActionButtons]"></ng-content>

    <ng-container actionButtons>
        @if (showImportExport) {
            <clmi-hybrid-select-menu
                class="d-inline-block ms-2"
                [disableExport]="totalRecordCount === 0"
                [dropdownMenuImportPrivilege]="importPrivilege"
                [dropdownMenuExportPrivilege]="exportPrivilege"
            ></clmi-hybrid-select-menu>
        }
        <ng-content select="[actionButtons]"></ng-content>
    </ng-container>
</molecule-search-bar>

@if (filterHandler) {
    <atom-modal-wrapper [modalId]="instanceId" [modalTemplate]="filterModal">
        <ng-template #filterModal>
            <organism-modal modalTitle="Filter">
                @if (hasFilterSearch) {
                    <clmi-form-filters class="h-100 w-100"></clmi-form-filters>
                }
            </organism-modal>
        </ng-template>
    </atom-modal-wrapper>
}
